import React, { useEffect, useState } from "react";
import { SkillsTypeEnum } from "../../../../../constants/LanguageConstants";
import {
  LINGUISTIC_LABEL,
  TECHS_LABEL,
} from "../../../../../constants/Dictionary";
import {
  OptionItem,
  TextSwitch,
} from "../../../../../components/TextSwitch/TextSwitch";
import { LanguagesHistory } from "./Languages/LanguagesHistory";
import { TechSkillsHistory } from "./Techniques/TechSkillsHistory";
import {
  CollaboratorCmSheet,
  CollaboratorDetails,
} from "../../../../../types/api/collaborators.type";

type SkillsHistoryProps = {
  setTextSwitch: (component: React.ReactNode) => void;
  setLink: (component: React.ReactNode) => void;
  collaborator: CollaboratorDetails;
  onStatusRefresh: () => void;
  isMyProfile?: boolean;
  setHistoryRefetchFn?: (fn: () => void) => void;
  currentCmSheet?: CollaboratorCmSheet;
};

export const SkillsHistory = ({
  setTextSwitch,
  setLink: addLink,
  collaborator,
  onStatusRefresh,
  isMyProfile,
  setHistoryRefetchFn,
  currentCmSheet,
}: SkillsHistoryProps) => {
  const SkillsTypeOptions = [
    { value: SkillsTypeEnum.LANGUAGE, label: LINGUISTIC_LABEL },
    { value: SkillsTypeEnum.TECH, label: TECHS_LABEL },
  ];

  const [selectedSkillsType, setSelectedSkillsType] = useState<
    OptionItem<SkillsTypeEnum>
  >(SkillsTypeOptions[0]);

  useEffect(() => {
    setTextSwitch(
      <TextSwitch
        selectedOption={selectedSkillsType}
        setSelectedOption={setSelectedSkillsType}
        options={SkillsTypeOptions}
      />,
    );
  }, [selectedSkillsType]);

  return (
    <div className="content">
      {selectedSkillsType.value === SkillsTypeEnum.LANGUAGE && (
        <LanguagesHistory
          collaborator={collaborator}
          setLink={addLink}
          isMyProfile={isMyProfile}
          onStatusRefresh={onStatusRefresh}
          setHistoryRefetchFn={setHistoryRefetchFn}
          currentCmSheet={currentCmSheet}
        />
      )}
      {selectedSkillsType.value === SkillsTypeEnum.TECH && (
        <TechSkillsHistory
          collaborator={collaborator}
          addLink={addLink}
          isMyProfile={isMyProfile}
          onStatusRefresh={onStatusRefresh}
          setHistoryRefetchFn={setHistoryRefetchFn}
          currentCmSheet={currentCmSheet}
        />
      )}
    </div>
  );
};
